
<div class="card">
    <div class="card-body">
      <h2>Post a Question</h2>
      <form #quForm="ngForm" (ngSubmit)="quForm.form.valid && save()" autocomplete="off">
        <div class="row">

          <div class="col-12 col-md-4 form-group">
            <label for="domain">Domain</label>
            <select class="select form-control" name="Domain" [(ngModel)]="model.departmentId"
            required [ngClass]="{'is-invalid': domain.invalid && quForm.submitted}" #domain="ngModel"
            (change)="getAllCategoriesByDepId()" id="domain">
              <option [ngValue]="undefined">Select Domain</option>
              <option *ngFor="let dept of allDepartments" [value]="dept.id">{{dept.name}}</option>
            </select>
            <small id="message" class="text-muted" *ngIf="domain.invalid && quForm.submitted">
              Domain is required
            </small>
          </div>


          <div class="col-12 col-md-4 form-group">
            <label for="category">Category</label>
            <select class="select form-control" name="category" (change)="getAllSubCategoriesByCategoryId()"
            required [ngClass]="{'is-invalid': category.invalid && quForm.submitted}" #category="ngModel"  
            [(ngModel)]="model.categoryId" id="category">
              <option [ngValue]="undefined">Select Category</option>
              <option *ngFor="let cate of allCategories" [value]="cate.id">{{cate.name}}</option>
            </select>
            <small id="message" class="text-muted" *ngIf="category.invalid && quForm.submitted">
              Category is required
            </small>
          </div>


          <div class="col-12 col-md-4 form-group">
            <label for="select subcategory">Sub Category</label>
            <select class="form-control" name="SubCategory" [(ngModel)]="model.subCategoryId"
            required [ngClass]="{'is-invalid': subCategory.invalid && quForm.submitted}" #subCategory="ngModel"  
             id="subcategory">
              <option [ngValue]="undefined">Select Sub Category</option>
              <option *ngFor="let subCate of allSubCategories" [value]="subCate.id">{{subCate.name}}</option>
            </select>
            <small id="message" class="text-muted" *ngIf="subCategory.invalid && quForm.submitted">
              SubCategory is required
            </small>
          </div>

        </div>
        <!-- Tab Menu -->
        <nav class="user-tabs mb-4">
          <ul class="nav nav-tabs nav-tabs-bottom">
            <li class="nav-item">
              <a class="nav-link active" href="#textid" data-toggle="tab"> <i class="fas fa-text-height" aria-hidden="true"></i>  &nbsp; Text</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" href="#audioid" data-toggle="tab"> <i class="fa fa-microphone" aria-hidden="true"></i> &nbsp; Audio</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#videoId" data-toggle="tab"><i class="fas fa-video"></i> &nbsp; Video</a>
        </li>
          </ul>
      </nav>
      <!-- /Tab Menu -->
  
      <div class="tab-content pt-0" style="min-height: 400px;">
        <div id="textid" class="tab-pane fade show active">
            <h3>write about your question</h3>
  
            <div class="row clearfix">
              <div class="col-12 col-md-6">
                <p-editor [(ngModel)]="model.questionDetail"  #Editor name="editor" [style]="{'height':'300px'}"></p-editor>
                <!-- <small class="text-muted"> * You must enter minimum 50 Characters.</small> -->
              </div>
              <div class="col-12 col-md-6">
                <p-fileUpload name="myfile[]" [auto]="true" class="uploader-h" customUpload="true" multiple="multiple"
                (uploadHandler)="myUploader($event)"></p-fileUpload>
                  <!-- <table class="table table-striped table-inverse">
                    <thead class="thead-inverse">
                      <tr>
                        <th>#</th>
                        <th>File</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of model.questionDocuments;let index=index;">
                          <td scope="row">{{index+1}}</td>
                          <td><i class="fa fa-file-download"></i></td>
                          <td><i class="fa fa-times"></i></td>
                        </tr>
                      </tbody>
                  </table> -->
              </div>
  
            </div>
        </div>
        <div id="audioid" class="tab-pane fade">
          <div class="row clearfix">
            <div class="form-group col-12 col-md-6">
              <div class="upload-img">
                <div class="change-audio-btn">
                  <span><i class="fa fa-upload" aria-hidden="true"></i> &nbsp; Upload Audio</span>
                  <input type="file" class="upload" accept="audio/*" (change)="recordChange($event)" capture>
                </div>
                <small class="form-text text-muted">Allowed only .mp3 Max size of 5MB</small>
                <br>
        
                <div class="change-audio-btn" *ngIf="!isRecording && !blobUrl" (click)="startRecording()">
                  <span><i class="fa fa-play" aria-hidden="true"></i> &nbsp; Start Recording</span>
                </div>
                <div class="change-audio-btn" *ngIf="isRecording && !blobUrl" (click)="stopRecording()">
                  <span><i class="fa fa-stop" aria-hidden="true"></i> &nbsp; Stop Recording</span>
                </div>
                <div class="change-audio-btn" *ngIf="!isRecording && blobUrl" (click)="clearRecordedData()">
                  <span> &nbsp;Clear Recording</span>
                </div>
                <h3 class="badge badge-pill bg-secondary-light">Time: {{recordedTime}}</h3>
              </div>
              <div class="">
                <audio id="player" controls name="recordPlayer" [src]="record"></audio>
              </div>
            </div>
            <div>
              <!-- <span style="cursor: pointer;" *ngIf="!isRecording && !blobUrl" (click)="startRecording()">Start Recording</span>
                    <span style="cursor: pointer;"  *ngIf="isRecording && !blobUrl" (click)="stopRecording()">Stop Recording</span>
                    <span style="cursor: pointer;" *ngIf="!isRecording && blobUrl" (click)="clearRecordedData()">Clear Recording</span> -->
              <!-- <span>Recording Time</span>
                    <div *ngIf="isRecording && !blobUrl"> {{recordedTime}} </div> -->
              <div>
                <!-- <audio *ngIf="!isRecording && blobUrl"  controls>
                      <source [src]="blobUrl" type="audio/webm">
                    </audio> -->
              </div>
            </div>
      
          </div>
        </div>
        <div id="videoId" class="tab-pane fade show">
          <div class="form-group col-12 col-md-6">
            <div class="upload-img">
              <div class="change-audio-btn">
                <span><i class="fa fa-upload" aria-hidden="true"></i> &nbsp; Upload Video</span>
                <input type="file" id="file" class="upload" accept="video/*" (change)="VideoChange($event.target.files)">
              </div>
              <small class="form-text text-muted">Allowed only .mp4 Max size of 25MB</small>
          </div>
  
          </div>
      </div>
      </div>
        
      <div class="submit-section" style="margin-top:10px">
        <button type="submit" [buttonBusy]="saving" class="btn btn-primary submit-btn">Next</button>
    </div>
      </form>
    </div>
  </div>

  